import React from "react";
import {useCsContext} from "../../state/CsInstance";
import {observer} from "mobx-react-lite";
import BaseModal from "./BaseModal";

/**
 * Global modal that lives on top of the app.  There should be no other modals
 * except for the method manifest (a special case that only covers the IDE).
 */
const GlobalModal = () => {
	const {globalModalStore} = useCsContext();

	return (
		<BaseModal
			id="globalModalOverlay"
			isOpen={globalModalStore.isOpen}
			toggle={() => globalModalStore.closeModal()}
		>
			{globalModalStore.modalContent}
		</BaseModal>
	);
};

export default observer(GlobalModal);
